<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 18:10:23
 * @LastEditTime: 2019-09-03 17:04:37
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="add container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本资料" name="first">
                <el-form ref="form" :model="form" label-width="100px" :rules="formRules">
                    <el-form-item label="业务员编号" prop="dealer_sn">
                        <el-input v-model="form.dealer_sn" :readonly="dealer_sn" placeholder="请输入编号"></el-input>
                    </el-form-item>
                    <el-form-item label="业务员名称" prop="dealer_name">
                        <el-input v-model="form.dealer_name" :readonly="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="账号" prop="mobile_son">
                        <el-input v-model="form.mobile_son" :readonly="readonly"></el-input>
                        <span>-{{ mobile }}</span>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="form.password" type="password" :readonly="readonly"
                            :placeholder="$route.query.edit ? '不修改请留空，输入则修改密码' : '请输入密码'"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="repassword" v-if="!dealer_sn">
                        <el-input v-model="form.repassword" type="password" :readonly="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="form.msg"></el-input>
                    </el-form-item>
                    <el-form-item label="管辖门店">
                        <el-button type="primary" plain @click="openSelectStore">选择门店</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-table :data="pagedSelectedStores" border size="mini" style="width: 600px">
                            <el-table-column prop="shop_sn" label="门店编号" width="180"></el-table-column>
                            <el-table-column prop="shop_name" label="门店名称"></el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small"
                                        @click="removeSelectedStore(scope.row.shop_sn)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination style="margin-top: 12px" :current-page="selectedStorePageNo"
                            :page-sizes="[20, 30, 50, 100]" :page-size="selectedStorePageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="selectedStores.length"
                            @size-change="handleSelectedStoreSizeChange"
                            @current-change="handleSelectedStoreCurrentChange" />
                    </el-form-item>
                </el-form>
                <div class="footer">
                    <el-button type="primary" @click="save()">保存</el-button>
                    <el-button @click="$router.go(-1)">返回</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="分配PC端权限" name="second">
                <el-tree ref="tree" @check-change="getData" :data="list" show-checkbox node-key="id"
                    :default-expand-all="true" :default-checked-keys="defaultChecked" :props="defaultProps">
                </el-tree>

                <div class="footer">
                    <el-button type="primary" @click="save">保存</el-button>
                    <el-button @click="back">返回</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="分配手机端权限" name="second_app">
                <el-tree ref="tree_app" @check-change="getDataApp" :data="list_app" show-checkbox node-key="id"
                    :default-expand-all="true" :default-checked-keys="defaultChecked_app" :props="defaultProps_app">
                </el-tree>

                <div class="footer">
                    <el-button type="primary" @click="save">保存</el-button>
                    <el-button @click="back">返回</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
        <selectStore v-if="selectStoreDialog" :selects="true" :defaultSelectedShopSns="getShopSns()"
            @handleClose="selectStoreDialog = false" @pushData="getSelectedStores" />
    </div>
</template>

<script>
    import { setTimeout } from "timers";
    import selectStore from "@/common/selectStore";
    export default {
        name: "addStaff",
        components: {
            selectStore,
        },
        data () {
            return {
                activeName: "first",
                activeNames: "",
                activeNames_app: "",
                form: {},
                mobile: "",
                dealer_sn: false,
                readonly: false,
                rea_psw: false,
                rules: {
                    dealer_sn: [{ required: true, message: "请输入业务员编号", trigger: "blur" }],
                    dealer_name: [{ required: true, message: "请输入业务员名称", trigger: "blur" }],
                    mobile_son: [{ required: true, message: "请输入账号", trigger: "blur" }],
                    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                    repassword: [{ required: true, message: "请再次输入密码", trigger: "blur" }],
                },
                data: [
                    {
                        id: 1,
                        label: "一级 1",
                        children: [
                            {
                                id: 4,
                                label: "二级 1-1",
                                children: [
                                    {
                                        id: 9,
                                        label: "三级 1-1-1",
                                    },
                                    {
                                        id: 10,
                                        label: "三级 1-1-2",
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: 2,
                        label: "一级 2",
                        children: [
                            {
                                id: 5,
                                label: "二级 2-1",
                            },
                            {
                                id: 6,
                                label: "二级 2-2",
                            },
                        ],
                    },
                    {
                        id: 3,
                        label: "一级 3",
                        children: [
                            {
                                id: 7,
                                label: "二级 3-1",
                            },
                            {
                                id: 8,
                                label: "二级 3-2",
                            },
                        ],
                    },
                ],
                list: [],
                list_app: [],
                selectStoreDialog: false,
                selectedStores: [],
                selectedStorePageNo: 1,
                selectedStorePageSize: 10,
                defaultChecked: [],
                checkList: [],
                defaultChecked_app: [],
                checkList_app: [],
                defaultProps: {
                    children: "children",
                    label: "label",
                },
                defaultProps_app: {
                    children: "children",
                    label: "label",
                },
            };
        },
        created () {
            this.init();

        },
        computed: {

            // 已选门店前端分页切片，避免门店过多时页面过长
            pagedSelectedStores () {
                const maxPage = this.getSelectedStoreMaxPage();
                const safePageNo = Math.min(Math.max(1, this.selectedStorePageNo), maxPage);
                const start = (safePageNo - 1) * this.selectedStorePageSize;
                const end = start + this.selectedStorePageSize;
                return this.selectedStores.slice(start, end);
            },
            formRules () {
                if (!this.$route.query.edit) {
                    return this.rules;
                }
                return {
                    ...this.rules,
                    password: [],
                    repassword: [],
                };
            },
        },
        methods: {
            // 计算已选门店最大页数，防止翻页越界后出现空页
            getSelectedStoreMaxPage () {
                return Math.max(1, Math.ceil(this.selectedStores.length / this.selectedStorePageSize));
            },
            handleClick () { },
            collectCheckedKeys (list) {
                const checkedKeys = [];
                const walk = (items) => {
                    if (!Array.isArray(items)) {
                        return;
                    }
                    items.forEach((item) => {
                        if (item.check) {
                            checkedKeys.push(item.id);
                        }
                        if (item.children && item.children.length) {
                            walk(item.children);
                        }
                    });
                };
                walk(list);
                return checkedKeys;
            },
            setTreeCheckedKeys (treeRef, checkedKeys, checkListName) {
                this[checkListName] = checkedKeys.slice();
                this.$nextTick(() => {
                    const tree = this.$refs[treeRef];
                    if (!tree) {
                        return;
                    }
                    tree.setCheckedKeys(checkedKeys);
                    this[checkListName] = tree.getCheckedKeys().concat(tree.getHalfCheckedKeys());
                });
            },
            init () {
                if (this.$route.query.edit) {
                    // console.log(this.$route.query.edit)
                    this.dealer_sn = true;
                    this.readonly = false;
                    this.mobile = sessionStorage.getItem("mobile");
                    this.$get("logistics_2", "publics/Dealerpc.Dealerpc/editveendorrbac", {
                        customer_id: sessionStorage.getItem("customer_id"),
                        mobile: sessionStorage.getItem("mobile"),
                        mobile_son: this.$route.query.edit,
                    }).then((res) => {
                        this.list = res.menu || [];
                        this.list_app = res.menus_app || [];
                        this.defaultChecked = this.collectCheckedKeys(this.list);
                        this.defaultChecked_app = this.collectCheckedKeys(this.list_app);
                        this.setTreeCheckedKeys("tree", this.defaultChecked, "checkList");
                        this.setTreeCheckedKeys("tree_app", this.defaultChecked_app, "checkList_app");
                        this.activeNames = this.list[0] ? this.list[0].id : "";
                        this.activeNames_app = this.list_app[0] ? this.list_app[0].id : "";
                    });
                    this.$get("logistics_2", "publics/Dealerpc.Dealerpc/geteidtVendor", {
                        customer_id: sessionStorage.getItem("customer_id"),
                        mobile: sessionStorage.getItem("mobile"),
                        mobile_son: this.$route.query.edit,
                    }).then((res) => {
                        this.form = res.msg;
                        this.form.password = "";
                        this.form.repassword = "";
                        this.form.mobile_son = res.msg.mobile.replace(
                            "-" + sessionStorage.getItem("mobile"),
                            ""
                        );
                        this.setSelectedStoresFromEdit(res.msg);
                    });
                } else {
                    this.readonly = false;
                    this.mobile = sessionStorage.getItem("mobile");
                    this.$get("logistics_2", "publics/Dealerpc.Dealerpc/addvendorrbac", {
                        customer_id: sessionStorage.getItem("customer_id"),
                        mobile: sessionStorage.getItem("mobile"),
                    }).then((res) => {
                        this.list = res.menu;
                        this.list_app = res.menus_app;
                        this.activeNames = this.list[0].id;
                        this.activeNames_app = this.list_app[0].id;
                    });
                }
            },
            loadNode (node, resolve) {
                if (node.level === 0) {
                    return resolve([{ name: "region" }]);
                }
                if (node.level > 1) return resolve([]);

                setTimeout(() => {
                    const data = [
                        {
                            name: "leaf",
                            leaf: true,
                        },
                        {
                            name: "zone",
                        },
                    ];

                    resolve(data);
                }, 500);
            },
            handleCheckChange (change) { },
            getData (leafOnly) {
                this.checkList = [];
                this.checkList = this.$refs.tree
                    .getCheckedKeys()
                    .concat(this.$refs.tree.getHalfCheckedKeys());
            },
            getDataApp (leafOnly) {
                this.checkList_app = [];
                this.checkList_app = this.$refs.tree_app
                    .getCheckedKeys()
                    .concat(this.$refs.tree_app.getHalfCheckedKeys());
                console.log(this.checkList_app)
            },
            back () {
                this.$router.push({
                    name: "staffManagement",
                });
            },
            openSelectStore () {
                this.selectStoreDialog = true;
            },
            getSelectedStores (rows) {
                const list = Array.isArray(rows) ? rows : [rows];
                const map = {};
                this.selectedStores.forEach((item) => {
                    map[item.shop_sn] = item;
                });
                list.forEach((item) => {
                    if (item && item.shop_sn) {
                        map[item.shop_sn] = item;
                    }
                });
                this.selectedStores = Object.keys(map).map((key) => map[key]);
                // 选择完成后定位到最后一页，方便看到最新选择
                this.selectedStorePageNo = Math.max(
                    1,
                    Math.ceil(this.selectedStores.length / this.selectedStorePageSize)
                );
                this.selectStoreDialog = false;
            },
            removeSelectedStore (shopSn) {
                this.selectedStores = this.selectedStores.filter((item) => item.shop_sn !== shopSn);
                // 删除后若当前页超出最大页，自动回退到最后一页
                const maxPage = Math.max(
                    1,
                    Math.ceil(this.selectedStores.length / this.selectedStorePageSize)
                );
                if (this.selectedStorePageNo > maxPage) {
                    this.selectedStorePageNo = maxPage;
                }
            },
            // 已选门店分页：切换每页条数
            handleSelectedStoreSizeChange (size) {
                this.selectedStorePageSize = size;
                this.selectedStorePageNo = 1;
            },
            // 已选门店分页：切换页码时做边界保护
            handleSelectedStoreCurrentChange (page) {
                const maxPage = this.getSelectedStoreMaxPage();
                this.selectedStorePageNo = Math.min(Math.max(1, page), maxPage);
            },
            getShopSns () {
                return this.selectedStores.map((item) => item.shop_sn).filter((item) => !!item);
            },
            setSelectedStoresFromEdit (msg) {
                if (!msg) {
                    return;
                }
                if (Array.isArray(msg.shop_list) && msg.shop_list.length) {
                    this.selectedStores = msg.shop_list;
                    return;
                }
                if (Array.isArray(msg.shop_sns) && msg.shop_sns.length) {
                    this.selectedStores = msg.shop_sns.map((shopSn) => ({
                        shop_sn: shopSn,
                        shop_name: "",
                    }));
                    return;
                }
                // 兼容编辑详情返回 store_sns 字段（字符串数组）
                if (Array.isArray(msg.store_sns) && msg.store_sns.length && typeof msg.store_sns[0] === "string") {
                    this.selectedStores = msg.store_sns.map((shopSn) => ({
                        shop_sn: shopSn,
                        shop_name: "",
                    }));
                    return;
                }
                // 兼容编辑详情返回 store_sns 对象数组：[{store_sn, storename}]
                if (Array.isArray(msg.store_sns) && msg.store_sns.length && typeof msg.store_sns[0] === "object") {
                    this.selectedStores = msg.store_sns.map((item) => ({
                        shop_sn: item.store_sn || item.shop_sn || "",
                        shop_name: item.storename || item.shop_name || "",
                    })).filter((item) => !!item.shop_sn);
                }
            },
            save () {
                if (this.$route.query.edit) {
                    this.$refs["form"].validate((valid) => {
                        if (valid) {
                            if (this.checkList.length == 0 || this.checkList_app.length == 0) {
                                this.$message({
                                    type: "error",
                                    message: "至少选中一个权限",
                                });
                                return;
                            }
                            const params = {
                                msg: this.form.msg,
                                dealer_name: this.form.dealer_name,
                                mobile_son: this.form.mobile_son + "-" + sessionStorage.getItem("mobile"),
                                permissions: this.checkList,
                                permissions_app: this.checkList_app,
                                shop_sns: this.getShopSns(),
                                customer_id: sessionStorage.getItem("customer_id"),
                                mobile: this.mobile ? this.mobile : sessionStorage.getItem("mobile"),
                            };
                            // 编辑时密码不回显、不默认提交；只有输入新密码才修改密码，避免密文再次加密保存
                            if (this.form.password) {
                                params.password = this.form.password;
                            }
                            // 管辖门店允许为空，按当前选择直接提交 shop_sns
                            this.$get("logistics_2", "publics/Dealerpc.Dealerpc/editVendor", params).then((res) => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: "success",
                                        message: res.msg,
                                    });
                                    var that = this;
                                    setTimeout(() => {
                                        that.$router.push({
                                            name: "staffManagement",
                                        });
                                    }, 500);
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.msg,
                                    });
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                } else {
                    this.$refs["form"].validate((valid) => {
                        if (valid) {
                            if (this.form.repassword !== this.form.password) {
                                this.$message({
                                    type: "error",
                                    message: "两次密码输入不一致",
                                });
                                return;
                            }
                            if (this.checkList.length == 0 || this.checkList_app.length == 0) {
                                this.$message({
                                    type: "error",
                                    message: "至少选中一个权限",
                                });
                                return;
                            }
                            // 管辖门店允许为空，按当前选择直接提交 shop_sns
                            this.$get("logistics_2", "publics/Dealerpc.Dealerpc/addVendor", {
                                ...this.form,
                                permissions: this.checkList,
                                permissions_app: this.checkList_app,
                                shop_sns: this.getShopSns(),
                                customer_id: sessionStorage.getItem("customer_id"),
                                mobile: this.mobile ? this.mobile : sessionStorage.getItem("mobile"),
                            }).then((res) => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: "success",
                                        message: res.msg,
                                    });
                                    var that = this;
                                    setTimeout(() => {
                                        that.$router.push({
                                            name: "staffManagement",
                                        });
                                    }, 500);
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.msg,
                                    });
                                }


                            });
                        } else {
                            return false;
                        }
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    /deep/.el-input {
        width: 200px !important;
    }

    .footer {
        text-align: center;
        margin-top: 50px;
    }
</style>